import { Checkbox } from "@material-ui/core";
import React from "react";
import {
  FieldProps,
  Record,
  useRecordContext,
} from "react-admin";
import {Identifier} from "ra-core";

export const OverbookingEditableCheckboxField = (
  props: FieldProps & {
    source: string;
    disabled: (record: Record) => boolean;
    setLoadComplete: any,
    setActiveDelivery: (charge: Record | undefined) => void,
      selectedSegmentsIds: Identifier[],
      setSelectedSegmentsIds: React.Dispatch<React.SetStateAction<Identifier[]>>,
  }
) => {
  const { disabled, ...rest } = props;
  const record = useRecordContext(rest);
  return (
    <span onClick={(e) => e.stopPropagation()}>
      <Checkbox
        disabled={disabled(record)}
        checked={props.selectedSegmentsIds.includes(record.id) }
        onChange={(event) => {
            const checked = event.target.checked;
            const id = record.id;

            if (checked) {
                props.setSelectedSegmentsIds(prev =>
                    prev.includes(id) ? prev : [...prev, id]
                );
            } else {
                props.setSelectedSegmentsIds(prev =>
                    prev.filter(x => x !== id)
                );
            }
        }
      }
      />
    </span>
  );
};
